import { useState } from "react";
import { DownOutlined, RightOutlined } from "@ant-design/icons";

export function CollapsibleGroup(
  { title, children, defaultOpen = true } : 
  { title: string | undefined; children: React.ReactNode; defaultOpen?: boolean }
) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div style={{ border: "1px solid #d9d9d9", borderRadius: "8px", marginBottom: "16px", overflow: "hidden" }}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: "10px 16px",
          backgroundColor: "#f8f8f8",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 600
        }}>
        <span>{title}</span>
        {isOpen ? <DownOutlined/> : <RightOutlined/>}
      </div>
      {isOpen && <div style={{ padding: "16px 16px 0 16px" }}>{children}</div>}
    </div>
  );
}